document.addEventListener('DOMContentLoaded', (e) => {
	if (window.innerWidth <= 767) {
		const benefitsTitle = document.querySelector('.product-benefits__title');
		if (benefitsTitle) {
			const brItem = benefitsTitle.querySelector('br');
			if (brItem) {
				brItem.remove();
			}
		}
	}


	const swiper = new Swiper('.products-slider.swiper', {
		// Optional parameters
		loop: true,
		slidesPerView: 4.2,
		spaceBetween: 20,
		// Navigation arrows
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			clickable: true,
			el: ".products-slider-pagination.swiper-pagination",
		},
		breakpoints: {
			320: {
				slidesPerView: 1,
				spaceBetween: 20,
				navigation: false
			},
			640: {
				slidesPerView: 2,
				spaceBetween: 20,
				navigation: false
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 40,
			},
			1024: {
				slidesPerView: 3.5,
				spaceBetween: 20,
			}
		}
	});


	const swiper_frequently = new Swiper('.product_frequently_slider', {
		// Optional parameters
		loop: true,
		slidesPerView: 1,
		spaceBetween: 0,
		init: false,
		navigation: {
			nextEl: '.product_frequently_slider_button-next',
			prevEl: '.product_frequently_slider_button-prev',
		},
		pagination: {
			clickable: true,
			el: ".product_frequently_slider .swiper-pagination",
		} 
	});
	swiper_frequently.on('slideChange', function (e) {  
		const price = document.querySelector(`#product_frequently_item_${swiper_frequently.realIndex}`).dataset.price;
		document.querySelector('#frequentle_price').innerHTML=price
		
	}); 

	   swiper_frequently.on('init', function() {
		const price = document.querySelector(`#product_frequently_item_0`).dataset.price;
		document.querySelector('#frequentle_price').innerHTML=price
	   }); 
	   swiper_frequently.init();

	const swiper_minicart = new Swiper('.cart_product_like_slider', {
		// Optional parameters
		loop: true,
		slidesPerView: 1,
		spaceBetween: 0, 
		navigation: {
			nextEl: '.cart_product_like_slider-next',
			prevEl: '.cart_product_like_slider-prev',
		},
		pagination: {
			clickable: true,
			el: ".cart_product_like_slider .swiper-pagination",
		} 
	});
	if (document.querySelector('.swiper.testimonials__swiper')) {
		let swiperTest;
		function initSwiper() {
			if (!swiperTest) {
				swiperTest = new Swiper('.swiper.testimonials__swiper', {
					loop: true,
					spaceBetween: 20,
					slidesPerView: 1.5,
					pagination: {
						clickable: true,
						el: ".testimonials-pagination.swiper-pagination",
					},
					breakpoints: {
						320: {
							slidesPerView: 1,
							spaceBetween: 20,
						},
						576: {
							slidesPerView: 1.5,
							spaceBetween: 20,
						}
					}
				});
			}
		}

		function destroySwiper() {
			if (swiperTest) {
				console.log("Destroying Swiper");
				swiperTest.destroy();
				swiperTest = null;
			}
		}

		function checkWindowSize() {
			const width = window.innerWidth;


			if (width <= 750) {
				initSwiper();
			} else {
				destroySwiper();
			}
		}

		checkWindowSize();
		window.addEventListener('resize', checkWindowSize);


	}


});

